import { addNewSalesInvoicesPath } from "@routes/addNewSalesinvoices/path";
import { authManagementPath } from "@routes/authManagement/path";
import { customerListPath } from "@routes/basicInfo/customerList/path";
import { employeeListPath } from "@routes/basicInfo/employeeList/path";
import { financialYearListPath } from "@routes/basicInfo/financialYearList/path";
import { itemCategoryPath } from "@routes/basicInfo/itemCategoryManagement/path";
import { measurementUnitPath } from "@routes/basicInfo/measurementUnitManagement/path";
import { supplierListPath } from "@routes/basicInfo/supplierList/path";
import { warehouseListPath } from "@routes/basicInfo/warehouseList/path";
import { employeeCostManagementPath } from "@routes/costManagement/employeeCost/path";
import { storeCostManagementPath } from "@routes/costManagement/storeCost/path";
import { dashboardPath } from "@routes/dashboard/path";
import { debtPath } from "@routes/financialManagement/debt/path";
import { incomePath } from "@routes/financialManagement/income/path";
import { subscriptionPath } from "@routes/financialManagement/subscription/path";
import { notificationsPath } from "@routes/notifications/path";
import { plansManagementPath } from "@routes/plansManagement/path";
import { purchaseInvoicesPath } from "@routes/purchaseManagement/purchaseInvoices/path";
import { purchaseReturnsListPath } from "@routes/purchaseManagement/returnsList/path";
import { bestSellingItemsReportPath } from "@routes/reportManagement/bestSellingItemsReport/path";
import { employeeActivityReportPath } from "@routes/reportManagement/employeeActivityReport/path";
import { financialReportPath } from "@routes/reportManagement/financialReport/path";
import { generalSalesReportPath } from "@routes/reportManagement/generalSalesReport/path";
import { itemBasedSalesReportPath } from "@routes/reportManagement/itemBasedSalesReport/path";
import { purchaseReportPath } from "@routes/reportManagement/purchaseReport/path";
import { salesReportPath } from "@routes/reportManagement/salesReport/path";
import { supplierBasedSalesReportPath } from "@routes/reportManagement/supplierBasedSalesReport/path";
import { topCustomerReportPath } from "@routes/reportManagement/topCustomerReport/path";
import { warehouseCirculationReportManagementPath } from "@routes/reportManagement/warehouseCirculationReport/path";
import { returnsListPath } from "@routes/salesManagement/returnsList/path";
import { salesInvoicePath } from "@routes/salesManagement/salesInvoice/path";
import { settingsPath } from "@routes/settings/path";
import { storesManagementPath } from "@routes/storesManagement/path";
import { supportPath } from "@routes/support/path";
import { centralWarehouseInventoryPath } from "@routes/warehouseManagement/centralWarehouseInventory/path";
import { priceListPath } from "@routes/warehouseManagement/priceList/path";
import { quantityInventoryOfWasteWarehousePath } from "@routes/warehouseManagement/quantityInventoryOfWasteWarehouse/path";
import { salesWarehouseInventoryPath } from "@routes/warehouseManagement/salesWarehouseInventory/path";
import { warehouseCirculationReportPath } from "@routes/warehouseManagement/warehouseCirculationReport/path";

export const routePath = removePathSuffix({
  dashboardPath,
  authManagementPath,
  settingsPath,
  supportPath,
  plansManagementPath,
  storesManagementPath,
  subscriptionPath,
  debtPath,
  incomePath,
  notificationsPath,
  customerListPath,
  employeeListPath,
  itemCategoryPath,
  measurementUnitPath,
  supplierListPath,
  warehouseListPath,
  employeeCostManagementPath,
  storeCostManagementPath,
  centralWarehouseInventoryPath,
  priceListPath,
  quantityInventoryOfWasteWarehousePath,
  salesWarehouseInventoryPath,
  warehouseCirculationReportPath,
  addNewSalesInvoicesPath,
  salesInvoicePath,
  returnsListPath,
  purchaseInvoicesPath,
  purchaseReturnsListPath,
  warehouseCirculationReportManagementPath,
  salesReportPath,
  bestSellingItemsReportPath,
  employeeActivityReportPath,
  financialReportPath,
  purchaseReportPath,
  topCustomerReportPath,
  generalSalesReportPath,
  itemBasedSalesReportPath,
  supplierBasedSalesReportPath,
  financialYearListPath,
} as const);

type IRemovePathSuffix<T> = {
  [K in keyof T as K extends `${infer Key}Path` ? Key : K]: T[K] extends (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args: any[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => any
    ? T[K]
    : T[K] extends object
      ? IRemovePathSuffix<T[K]>
      : T[K];
};

function removePathSuffix<T extends object>(obj: T): IRemovePathSuffix<T> {
  const result = {} as IRemovePathSuffix<T>;

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = key.endsWith("Path")
        ? (key.slice(0, -4) as keyof IRemovePathSuffix<T>)
        : (key as keyof IRemovePathSuffix<T>);
      const value = obj[key];

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (result as any)[newKey] =
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        typeof value !== "function"
          ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            removePathSuffix(value as any)
          : value;
    }
  }

  return result;
}
